<template>
  <div>
    <!-- 头部轮播图 -->
    <header>
      <Banner></Banner>
    </header>
    <!-- 主体内容 -->
    <main>
      <NavContent></NavContent>
    </main>
    <div class="code-twos">
      <div class="code-fonts">
        <div>
          <p>
            扫码关注<br />
            融畅易和
          </p>
          <p>成都融畅易和 科技有限公司</p>
        </div>
        <img src="@/assets/images/code.jpg" alt="" />
      </div>
    </div>
    <!-- 底部导航 -->
    <footer>
      <IndexFooter></IndexFooter>
    </footer>
    <!-- 工单 -->
    <work-order></work-order>
  </div>
</template>

<script>
import Banner from "../components/Banner.vue";
import NavContent from "../components/NavContent.vue";
import IndexFooter from "../components/IndexFooter.vue";
import WorkOrder from "../components/WorkOrder.vue";
export default {
  name: "",
  props: {},
  data() {
    return {};
  },
  components: { Banner, NavContent, IndexFooter, WorkOrder },
  methods: {},
  mounted() {},
  computed: {},
  watch: {},
};
</script>

<style lang="scss">
@import "../styles/common";
@import "../styles/reset.css";
.code-twos {
  width: 100%;
  display: flex;
  justify-content: center;
  .code-fonts {
    margin-bottom: 50px;
    width: 271px;
    height: 138px;
    background: #ffffff;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    align-items: center;
    display: flex;
    justify-content: space-between;
    div {
      margin-left: 30px;
      p {
        width: 85px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
      }
      p:nth-of-type(2) {
        width: 80px;
        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        margin-top: 10px;
      }
    }
    img {
      width: 103px;
      height: 103px;
      margin-right: 35px;
    }
  }
}
</style>